
import { Component, Vue, State } from 'nuxt-property-decorator';
import Slider from '../../Slider.vue';
import { SpeedSelection } from './models';
import ReadAloudStore from './read-aloud.store';
import ClientSettingsStore from '@/store/clientSettings.store';
import { Site } from '@/types/initialData';

@Component({
  components: { Slider }
})
export default class PollyReadingSpeed extends Vue {
  selectedReadingSpeed: number = 3;
  readingSpeeds: SpeedSelection[] = [
    {
      speed: 1,
      text: this.$tc('labels.polly.speed.x-slow')
    },
    {
      speed: 2,
      text: this.$tc('labels.polly.speed.slow')
    },
    {
      speed: 3,
      text: this.$tc('labels.polly.speed.medium')
    },
    {
      speed: 4,
      text: this.$tc('labels.polly.speed.fast')
    },
    {
      speed: 5,
      text: this.$tc('labels.polly.speed.x-fast')
    }
  ];

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site)
  site: Site;

  get speed(): number {
    return ReadAloudStore.speed.speed;
  }

  created() {
    this.setInitialReadingSpeed();
  }

  updateReadingSpeed(speed: number): void {
    ReadAloudStore.speed = this.readingSpeeds[speed - 1];
    ReadAloudStore.settingsChanged = true;
    ClientSettingsStore.updateClientSettings(this.site);
  }

  setInitialReadingSpeed(): void {
    const currentSpeed = this.readingSpeeds.find((speed) => {
      return ReadAloudStore.speed.speed === speed.speed;
    });

    this.selectedReadingSpeed = currentSpeed.speed;
  }
}
